<template>
  <div>
    <v-menu
      v-model="menu"
      right
      transition="slide-x-reverse-transition"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="mr-2 elevation-0"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-col>
          <v-text-field
            ref="searchInput"
            v-model.trim="searchId"
            append-icon="mdi-magnify"
            placeholder="Search By ID"
            single-line
            clearable
            outlined
            hide-details
            dense
            autofocus
            type="number"
            @keyup.enter="searchById"
          />
        </v-col>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "SearchByID",
  props: {
    icon: {
      type: String,
      default: "mdi-pound-box"
    }
  },
  data: () => ({
    menu: false,
    searchId: ""
  }),
  mounted() {
    window.addEventListener("keydown", this.handleShortcut);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleShortcut);
  },
  methods: {
    searchById() {
      this.$emit("submit", { id: this.searchId });
      this.searchId = "";
      this.menu = false;
    },
    handleShortcut(e) {
      const tag = document.activeElement.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;

      if (e.key === "/") {
        e.preventDefault();
        this.menu = true;
        this.$nextTick(() => {
          this.$refs.searchInput?.focus();
        });
      }
    }
  }
};
</script>